import { Link, useLocation } from "react-router-dom";

const TABS = [
  { to: "/admin/dashboard", label: "Dashboard" },
  { to: "/admin/sites", label: "Websites" },
  { to: "/admin/sales", label: "Sales" },
  { to: "/admin/finance", label: "Finance" },
  { to: "/admin/compliance", label: "Legal & Compliance" },
  { to: "/admin/handover", label: "Handover" },
  { to: "/admin/monitoring", label: "Monitoring" },
];

export default function AdminNavTabs() {
  const { pathname } = useLocation();
  return (
    <nav className="mt-6 flex gap-1 overflow-x-auto border-b border-slate-200" data-testid="admin-nav-tabs">
      {TABS.map((tab) => {
        const active = pathname === tab.to || (tab.to !== "/admin/dashboard" && pathname.startsWith(tab.to));
        return (
          <Link
            key={tab.to}
            to={tab.to}
            className={`px-4 py-2.5 text-sm font-semibold whitespace-nowrap border-b-2 -mb-px transition-colors ${
              active ? "border-emerald-600 text-emerald-700" : "border-transparent text-slate-500 hover:text-slate-800"
            }`}
          >
            {tab.label}
          </Link>
        );
      })}
    </nav>
  );
}
